module.exports = __webpack_public_path__ + "static/media/roadmap-img.e9ab1831.svg";